import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @module Errors
 *
 * @description Exports error classes which may be returned by this client
 */
// Take note of https://github.com/Microsoft/TypeScript/issues/13965

/**
 * IdealPostcodesError
 *
 * Base error class for all API responses that return an error. This class
 * is used where a JSON body is not provided or invalid
 * E.g. 503 rate limit response, JSON parse failure response
 */
export var IdealPostcodesError = /*#__PURE__*/function (_Error) {
  _inherits(IdealPostcodesError, _Error);

  var _super = _createSuper(IdealPostcodesError);

  /**
   * Instantiate IdealPostcodesError
   */
  function IdealPostcodesError(options) {
    var _this;

    _classCallCheck(this, IdealPostcodesError);

    var trueProto = (this instanceof IdealPostcodesError ? this.constructor : void 0).prototype;
    _this = _super.call(this);
    _this.__proto__ = trueProto;
    var message = options.message,
        httpStatus = options.httpStatus,
        _options$metadata = options.metadata,
        metadata = _options$metadata === void 0 ? {} : _options$metadata;
    _this.message = message;
    _this.name = "Ideal Postcodes Error";
    _this.httpStatus = httpStatus;
    _this.metadata = metadata;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), IdealPostcodesError);
    }

    return _this;
  }

  return _createClass(IdealPostcodesError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * IdpcApiError
 *
 * Base error class for API responses with a JSON body. Typically a subclass
 * will be used to capture the error category (e.g. 400, 401, 500, etc)
 */

export var IdpcApiError = /*#__PURE__*/function (_IdealPostcodesError) {
  _inherits(IdpcApiError, _IdealPostcodesError);

  var _super2 = _createSuper(IdpcApiError);

  /**
   * Returns an API error instance
   */
  function IdpcApiError(httpResponse) {
    var _this2;

    _classCallCheck(this, IdpcApiError);

    _this2 = _super2.call(this, {
      httpStatus: httpResponse.httpStatus,
      message: httpResponse.body.message
    });
    _this2.response = httpResponse;
    return _this2;
  }

  return _createClass(IdpcApiError);
}(IdealPostcodesError);
/**
 * IdpcBadRequestError
 *
 * Captures API responses that return a 400 (Bad Request Error) response
 *
 * Examples include:
 * - Invalid syntax submitted
 * - Invalid date range submitted
 * - Invalid tag submitted
 */

export var IdpcBadRequestError = /*#__PURE__*/function (_IdpcApiError) {
  _inherits(IdpcBadRequestError, _IdpcApiError);

  var _super3 = _createSuper(IdpcBadRequestError);

  function IdpcBadRequestError() {
    _classCallCheck(this, IdpcBadRequestError);

    return _super3.apply(this, arguments);
  }

  return _createClass(IdpcBadRequestError);
}(IdpcApiError);
/**
 * IdpcUnauthorisedError
 *
 * Captures API responses that return a 401 (Unauthorised) response
 *
 * Examples include:
 * - Invalid api_key
 * - Invalid user_token
 * - Invalid licensee
 */

export var IdpcUnauthorisedError = /*#__PURE__*/function (_IdpcApiError2) {
  _inherits(IdpcUnauthorisedError, _IdpcApiError2);

  var _super4 = _createSuper(IdpcUnauthorisedError);

  function IdpcUnauthorisedError() {
    _classCallCheck(this, IdpcUnauthorisedError);

    return _super4.apply(this, arguments);
  }

  return _createClass(IdpcUnauthorisedError);
}(IdpcApiError);
/**
 * IpdcInvalidKeyError
 *
 * Invalid API Key presented for request
 */

export var IdpcInvalidKeyError = /*#__PURE__*/function (_IdpcUnauthorisedErro) {
  _inherits(IdpcInvalidKeyError, _IdpcUnauthorisedErro);

  var _super5 = _createSuper(IdpcInvalidKeyError);

  function IdpcInvalidKeyError() {
    _classCallCheck(this, IdpcInvalidKeyError);

    return _super5.apply(this, arguments);
  }

  return _createClass(IdpcInvalidKeyError);
}(IdpcUnauthorisedError);
/**
 * IdpcRequestFailedError
 *
 * Captures API responses that return a 402 (Request Failed) response
 *
 * Examples include:
 * - Key balance depleted
 * - Daily key limit reached
 */

export var IdpcRequestFailedError = /*#__PURE__*/function (_IdpcApiError3) {
  _inherits(IdpcRequestFailedError, _IdpcApiError3);

  var _super6 = _createSuper(IdpcRequestFailedError);

  function IdpcRequestFailedError() {
    _classCallCheck(this, IdpcRequestFailedError);

    return _super6.apply(this, arguments);
  }

  return _createClass(IdpcRequestFailedError);
}(IdpcApiError);
/**
 * IdpcBalanceDepleted
 *
 * Balance on key has been depleted
 */

export var IdpcBalanceDepletedError = /*#__PURE__*/function (_IdpcRequestFailedErr) {
  _inherits(IdpcBalanceDepletedError, _IdpcRequestFailedErr);

  var _super7 = _createSuper(IdpcBalanceDepletedError);

  function IdpcBalanceDepletedError() {
    _classCallCheck(this, IdpcBalanceDepletedError);

    return _super7.apply(this, arguments);
  }

  return _createClass(IdpcBalanceDepletedError);
}(IdpcRequestFailedError);
/**
 * IdpcLimitReachedError
 *
 * Limit reached. One of your lookup limits has been breached for today. This
 * could either be your total daily limit on your key or the individual IP
 * limit. You can either wait for for the limit to reset (after a day) or
 * manually disable or increase your limit.
 */

export var IdpcLimitReachedError = /*#__PURE__*/function (_IdpcRequestFailedErr2) {
  _inherits(IdpcLimitReachedError, _IdpcRequestFailedErr2);

  var _super8 = _createSuper(IdpcLimitReachedError);

  function IdpcLimitReachedError() {
    _classCallCheck(this, IdpcLimitReachedError);

    return _super8.apply(this, arguments);
  }

  return _createClass(IdpcLimitReachedError);
}(IdpcRequestFailedError);
/**
 * IdpcResourceNotFoundError
 *
 * Captures API responses that return a 404 (Resource Not Found) response
 *
 * Examples include:
 * - Postcode not found
 * - UDPRN not found
 * - Key not found
 */

export var IdpcResourceNotFoundError = /*#__PURE__*/function (_IdpcApiError4) {
  _inherits(IdpcResourceNotFoundError, _IdpcApiError4);

  var _super9 = _createSuper(IdpcResourceNotFoundError);

  function IdpcResourceNotFoundError() {
    _classCallCheck(this, IdpcResourceNotFoundError);

    return _super9.apply(this, arguments);
  }

  return _createClass(IdpcResourceNotFoundError);
}(IdpcApiError);
/**
 * IdpcPostcodeNotFoundError
 *
 * Requested postcode does not exist
 */

export var IdpcPostcodeNotFoundError = /*#__PURE__*/function (_IdpcResourceNotFound) {
  _inherits(IdpcPostcodeNotFoundError, _IdpcResourceNotFound);

  var _super10 = _createSuper(IdpcPostcodeNotFoundError);

  function IdpcPostcodeNotFoundError() {
    _classCallCheck(this, IdpcPostcodeNotFoundError);

    return _super10.apply(this, arguments);
  }

  return _createClass(IdpcPostcodeNotFoundError);
}(IdpcResourceNotFoundError);
/**
 * IdpcKeyNotFoundError
 *
 * Requested API Key does not exist
 */

export var IdpcKeyNotFoundError = /*#__PURE__*/function (_IdpcResourceNotFound2) {
  _inherits(IdpcKeyNotFoundError, _IdpcResourceNotFound2);

  var _super11 = _createSuper(IdpcKeyNotFoundError);

  function IdpcKeyNotFoundError() {
    _classCallCheck(this, IdpcKeyNotFoundError);

    return _super11.apply(this, arguments);
  }

  return _createClass(IdpcKeyNotFoundError);
}(IdpcResourceNotFoundError);
/**
 * IdpcUdprnNotFoundError
 *
 * Requested UDPRN does not exist
 */

export var IdpcUdprnNotFoundError = /*#__PURE__*/function (_IdpcResourceNotFound3) {
  _inherits(IdpcUdprnNotFoundError, _IdpcResourceNotFound3);

  var _super12 = _createSuper(IdpcUdprnNotFoundError);

  function IdpcUdprnNotFoundError() {
    _classCallCheck(this, IdpcUdprnNotFoundError);

    return _super12.apply(this, arguments);
  }

  return _createClass(IdpcUdprnNotFoundError);
}(IdpcResourceNotFoundError);
/**
 * IdpcUmprnNotFoundError
 *
 * Requested UMPRN does not exist
 */

export var IdpcUmprnNotFoundError = /*#__PURE__*/function (_IdpcResourceNotFound4) {
  _inherits(IdpcUmprnNotFoundError, _IdpcResourceNotFound4);

  var _super13 = _createSuper(IdpcUmprnNotFoundError);

  function IdpcUmprnNotFoundError() {
    _classCallCheck(this, IdpcUmprnNotFoundError);

    return _super13.apply(this, arguments);
  }

  return _createClass(IdpcUmprnNotFoundError);
}(IdpcResourceNotFoundError);
/**
 * IdpcServerError
 *
 * Captures API responses that return a 500 (Server Error) response
 */

export var IdpcServerError = /*#__PURE__*/function (_IdpcApiError5) {
  _inherits(IdpcServerError, _IdpcApiError5);

  var _super14 = _createSuper(IdpcServerError);

  function IdpcServerError() {
    _classCallCheck(this, IdpcServerError);

    return _super14.apply(this, arguments);
  }

  return _createClass(IdpcServerError);
}(IdpcApiError); // 200 Responses

var OK = 200; // 300 Responses

var REDIRECT = 300; // 400 Responses

var BAD_REQUEST = 400; // 401 Responses

var UNAUTHORISED = 401;
var INVALID_KEY = 4010; // 402 Responses

var PAYMENT_REQUIRED = 402;
var BALANCE_DEPLETED = 4020;
var LIMIT_REACHED = 4021; // 404 Responses

var NOT_FOUND = 404;
var POSTCODE_NOT_FOUND = 4040;
var KEY_NOT_FOUND = 4042;
var UDPRN_NOT_FOUND = 4044;
var UMPRN_NOT_FOUND = 4046; // 500 Responses

var SERVER_ERROR = 500;

var isSuccess = function isSuccess(code) {
  if (code < OK) return false;
  if (code >= REDIRECT) return false;
  return true;
};

var isObject = function isObject(o) {
  if (o === null) return false;
  if (typeof o !== "object") return false;
  return true;
};

var isErrorResponse = function isErrorResponse(body) {
  if (!isObject(body)) return false;
  if (typeof body.message !== "string") return false;
  if (typeof body.code !== "number") return false;
  return true;
};
/**
 * parse
 *
 * Parses API responses and returns an error for non 2xx responses
 *
 * Upon detecting an error an instance of IdealPostcodesError is returned
 */


export var parse = function parse(response) {
  var httpStatus = response.httpStatus,
      body = response.body;
  if (isSuccess(httpStatus)) return;

  if (isErrorResponse(body)) {
    // Test for specific API errors of interest
    var code = body.code;
    if (code === INVALID_KEY) return new IdpcInvalidKeyError(response);
    if (code === POSTCODE_NOT_FOUND) return new IdpcPostcodeNotFoundError(response);
    if (code === KEY_NOT_FOUND) return new IdpcKeyNotFoundError(response);
    if (code === UDPRN_NOT_FOUND) return new IdpcUdprnNotFoundError(response);
    if (code === UMPRN_NOT_FOUND) return new IdpcUmprnNotFoundError(response);
    if (code === BALANCE_DEPLETED) return new IdpcBalanceDepletedError(response);
    if (code === LIMIT_REACHED) return new IdpcLimitReachedError(response); // If no API errors of interest detected, fall back to http status code

    if (httpStatus === NOT_FOUND) return new IdpcResourceNotFoundError(response);
    if (httpStatus === BAD_REQUEST) return new IdpcBadRequestError(response);
    if (httpStatus === PAYMENT_REQUIRED) return new IdpcRequestFailedError(response);
    if (httpStatus === UNAUTHORISED) return new IdpcUnauthorisedError(response);
    if (httpStatus === SERVER_ERROR) return new IdpcServerError(response);
  } // Generate generic error (backstop)


  return new IdealPostcodesError({
    httpStatus: httpStatus,
    message: JSON.stringify(body)
  });
};